module.exports = __webpack_public_path__ + "static/bunnycloud-60979fe2b35e20f9473405964fa7d8a0.jpeg";